export enum PreconfiguredTimeRanges {
	ALL = 'ALL',
	LAST_FOUR_WEEKS = 'LAST_FOUR_WEEKS',
	LAST_MONTH = 'LAST_MONTH',
	LAST_WEEK = 'LAST_WEEK',
	THIS_MONTH = 'THIS_MONTH',
	THIS_WEEK = 'THIS_WEEK',
	TODAY = 'TODAY',
	YESTERDAY = 'YESTERDAY',
}

// Public API der MiniCalendar.vue-Instanz für Template-Refs — das *.vue-Shim
// liefert nur ComponentOptions, daher strukturale Typisierung.
export interface MiniCalendarRef {
	open: () => void;
	toggle: (event: Event) => void;
}
